<script>
  import { getApiHost } from './config';
  import { prefixHostToLinks, getHost, getCookie } from './utils';
  import { TopNavigation, RootStyle } from '@storytel/design-system-web';

  import { onMount, tick } from 'svelte';

  export let countryiso = '',
    language = '',
    rtl = false,
    isloggedin = false,
    color = 'pink',
    subdomain = '',
    env = 'prod',
    usetestids = undefined;

  let isMounted = false;
  let mofibo = false;
  let data = {};
  let homepage = null;

  // An issue with Svelte and web components makes props unavailable
  // when mounting the component. Therefore we wait one tick
  // https://github.com/sveltejs/svelte/issues/2227

  onMount(async () => {
    await tick();
    mofibo = countryiso === 'dk';
    isloggedin = isloggedin === 'true';
    rtl = rtl === 'true';

    data = await fetch(`${getApiHost(env)}/navigations/top/${countryiso}/${language}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((data) => data.json());

    const host = getHost(countryiso, env, subdomain);
    data = prefixHostToLinks(countryiso, language, host, data);
    homepage = prefixHostToLinks(countryiso, language, host, {
      url: `/${data.countryIso}/${data.language}/`,
    }).url;

    isMounted = true;
  });
</script>

<svelte:options tag={null} />
<RootStyle>
  <div dir={rtl ? 'rtl' : null}>
    <TopNavigation
      data={data.data}
      isLoggedIn={isloggedin}
      {mofibo}
      {color}
      {homepage}
      useTestIds={usetestids}
    />
  </div>
</RootStyle>
